import { Breadcrumbs, Grid, Typography, useTheme } from "@mui/material";
import NavigateNextIcon from '@mui/icons-material/NavigateNext';


// interface BreadcrumbsItems {
//     label: string;
//     href?: string;
// }

interface BreadCrumbsBarPros {
    breadcrumbsItems: string[];
}



const BreadCrumbsBar = ({breadcrumbsItems}: BreadCrumbsBarPros) => {
    const breadcrumbsCount = breadcrumbsItems.length
    const theme = useTheme();
    const breadcrumbParent = (props: string, i: any) => (
        <Typography key={i} color={theme.s10palette.S10Greygrey400} variant="subtitle2">
            {props}
        </Typography>
    );
    const breadcrumbLastLevel = (props: string, i: any) => (
        <Typography variant="subtitle2" key={i} color={theme.s10palette.S10Blueblue600}>
          {props}
        </Typography>
    );
    return (
        <Grid item width="100%">
            <Breadcrumbs separator={<NavigateNextIcon style={{fontSize: "1.5rem"}} />}>
                {breadcrumbsItems.map((b, i) => (
                    (i + 1) === breadcrumbsCount 
                        ? breadcrumbLastLevel(b, i)
                        : breadcrumbParent(b, i)
                ))}
            </Breadcrumbs>
        </Grid>
    )
}

export default BreadCrumbsBar;